"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComponentManager = _interopRequireDefault(require("../ComponentManager"));

var _DomMutation = _interopRequireDefault(require("./DomMutation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Component DOM.
 */
var ComponentDom = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {Element} componentElement Component element.
   * @param {ComponentBody} componentBody Component body.
   * @param {string} componentId Component unique id.
   */
  function ComponentDom(componentElement, componentBody, componentId) {
    _classCallCheck(this, ComponentDom);

    this.componentElement = componentElement;
    this.componentBody = componentBody;
    this.componentId = componentId;
    this.componentManager = new _ComponentManager.default(componentElement);
    this.componentManager.useComponentObservers = false;
    this._movedReferenceElements = null;
    this._movedElements = new Map();
  }
  /**
   * Updates the DOM.
   *
   * @param {Element|Node} newElement New element to update from.
   * @param {boolean} [forced=false] Will force render of child components.
   */


  _createClass(ComponentDom, [{
    key: "update",
    value: function update(newElement) {
      var forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this._resetUpdateState();

      this._updateDom(this.componentElement, newElement);

      this._updateRenderInsideComponent();

      if (this.componentManager.update(true, forced).length < this.componentManager.filterElements.length) {
        this.componentManager.update(true, forced);
      }

      this._renderMovedElements();

      this._resetUpdateState();
    }
    /**
     * Removes any render inside element.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this._movedElements.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;

          if (element.parentNode) {
            element.parentNode.removeChild(element);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.componentManager.destroy();
    }
    /**
     * Updates the DOM.
     *
     * @param {Element} oldElement Old element.
     * @param {Element} newElement New element.
     * @returns {DomMutation[]} DOM Mutations.
     */

  }, {
    key: "_updateDom",
    value: function _updateDom(oldElement, newElement) {
      this._removeWhiteSpaceNodes(newElement.childNodes);

      var children = Array.from(oldElement.childNodes);
      var newChildren = Array.from(newElement.childNodes);
      var treeMutation = new _DomMutation.default(null, 'childList');
      var mutations = [];

      for (var i = 0, max = newChildren.length; i < max; i++) {
        if (newChildren[i].tagName === 'IKEA-COMPONENT-BODY' && newChildren[i].getAttribute('data-body-id') === this.componentBody.id.toString()) {
          newChildren[i] = this.componentBody.element;
        }

        if (i < children.length) {
          if (children[i].nodeType !== newChildren[i].nodeType || children[i].tagName !== newChildren[i].tagName) {
            this._updateChangedNodeType(treeMutation, children, newChildren, i);
          } else {
            mutations = mutations.concat(this._updateNodeChanges(children, newChildren, i));
          }
        } else {
          this._updateAddedNode(treeMutation, oldElement, children, newChildren, i);
        }

        if (children[i].tagName === 'IKEA-COMPONENT') {
          this.componentManager.filterElements.unshift(children[i]);
        }
      }

      this._updateRemovedNodes(treeMutation, children, newChildren);

      if (treeMutation.addedNodes.length > 0 || treeMutation.removedNodes.length > 0) {
        mutations.unshift(treeMutation);
      }

      return mutations;
    }
    /**
     * Renders moved elements.
     */

  }, {
    key: "_renderMovedElements",
    value: function _renderMovedElements() {
      var _iterator2 = _createForOfIteratorHelper(this._movedElements.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var movedElement = _step2.value;
          this.componentManager.filterElements.unshift(movedElement);
          this.componentManager.renderComponent(movedElement, true);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Resets the update state.
     */

  }, {
    key: "_resetUpdateState",
    value: function _resetUpdateState() {
      this.componentManager.filterElements = [];
      this._movedReferenceElements = new Map();
    }
    /**
     * Updates node changes.
     *
     * @param {Node[]} children Children.
     * @param {Node[]} newChildren New Children.
     * @param {number} i Index.
     * @returns {DomMutation[]} DOM mutations.
     */

  }, {
    key: "_updateNodeChanges",
    value: function _updateNodeChanges(children, newChildren, i) {
      var component = children[i].tagName === 'IKEA-COMPONENT' ? this.componentManager.getByElement(children[i]) : null;
      var mutations = [];

      if (children[i].attributes) {
        var childrenAttr = [];

        for (var a = 0, max = children[i].attributes.length; a < max; a++) {
          childrenAttr.push(children[i].attributes[a].name);
        }

        for (var _a = 0, _max = newChildren[i].attributes.length; _a < _max; _a++) {
          var attr = newChildren[i].attributes[_a].name;
          var value = newChildren[i].attributes[_a].value;

          if (attr !== 'data-rendered' && attr !== 'data-ui-platform' && children[i].getAttribute(attr) !== value) {
            if (!component || attr !== 'data-props' && attr !== 'data-events' || component.isDestroyed || component.propHandler.hasChangedComponentName() || childrenAttr.includes('name')) {
              this._setAttribute(children[i], attr, value);

              mutations.push(new _DomMutation.default(attr));
            } else if (attr === 'data-props') {
              component.propHandler.updateStoredProps(value);
            } else if (attr === 'data-events') {
              component.eventHandler.updateStoredEvents(value);
            }
          }

          var indexOf = childrenAttr.indexOf(attr);

          if (indexOf !== -1) {
            childrenAttr.splice(indexOf, 1);
          }
        }

        for (var _i = 0, _childrenAttr = childrenAttr; _i < _childrenAttr.length; _i++) {
          var _attr = _childrenAttr[_i];

          if (_attr !== 'data-rendered' && _attr !== 'data-ui-platform' && (!component || !component.propHandler.defaultedAttributes[_attr])) {
            this._removeAttribute(children[i], _attr);

            mutations.push(new _DomMutation.default(_attr));
          }
        }
      }

      if (!component && children[i].nodeValue !== newChildren[i].nodeValue) {
        children[i].nodeValue = newChildren[i].nodeValue;
        mutations.push(new _DomMutation.default());
      }

      if (component) {
        component.$mutations = this._updateDom(component.body.element, newChildren[i]);
      } else if (children[i].tagName !== 'IKEA-COMPONENT-BODY') {
        mutations = mutations.concat(this._updateDom(children[i], newChildren[i]));
      } else {
        var newHtmlState = children[i].innerHTML;
        var htmlState = children[i].$htmlState;

        if (newHtmlState !== htmlState) {
          children[i].$htmlState = newHtmlState;
          mutations.push(new _DomMutation.default());
        }
      }

      return mutations;
    }
    /**
     * Sets attribute on an element.
     *
     * @param {Element} element Element.
     * @param {string} attr Attribute name.
     * @param {string} value Attribute value.
     */

  }, {
    key: "_setAttribute",
    value: function _setAttribute(element, attr, value) {
      // Handle selected value in select box
      if (element.tagName && element.tagName === 'OPTION' && element.parentNode && element.parentNode.tagName === 'SELECT' && attr === 'selected') {
        element.parentNode.selectedIndex = Array.from(element.parentNode.options).indexOf(element);
      } // Handle selected value in input


      if (element.tagName && element.tagName === 'INPUT') {
        if (attr === 'value') {
          element.value = value;
        } else if (element.type === 'checkbox' && attr === 'checked') {
          element.checked = true;
        }
      }

      element.setAttribute(attr, value);
    }
    /**
     * Removes an attribute on an element.
     *
     * @param {Element} element Element.
     * @param {string} attr Attribute name.
     */

  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(element, attr) {
      element.removeAttribute(attr); // Handle selected value in input

      if (element.tagName && element.tagName === 'INPUT') {
        if (attr === 'value') {
          element.value = '';
        } else if (element.type === 'checkbox' && attr === 'checked') {
          element.checked = false;
        }
      }
    }
    /**
     * Updates an added node.
     *
     * @param {DomMutation} treeMutation Tree mutation.
     * @param {Element} oldElement Old element.
     * @param {Node[]} children Children.
     * @param {Node[]} newChildren New Children.
     * @param {number} i Index.
     */

  }, {
    key: "_updateAddedNode",
    value: function _updateAddedNode(treeMutation, oldElement, children, newChildren, i) {
      if (newChildren[i].querySelectorAll) {
        this.componentManager.filterElements = Array.from(newChildren[i].querySelectorAll('ikea-component')).concat(this.componentManager.filterElements);
      }

      this._replaceComponentBody(newChildren[i]);

      children.push(newChildren[i]);
      oldElement.appendChild(newChildren[i]);
      treeMutation.addedNodes.push(newChildren[i]);
    }
    /**
     * Updates removed nodes.
     *
     * @param {DomMutation} treeMutation Tree mutation.
     * @param {Node[]} children Children.
     * @param {Node[]} newChildren New Children.
     */

  }, {
    key: "_updateRemovedNodes",
    value: function _updateRemovedNodes(treeMutation, children, newChildren) {
      for (var i = newChildren.length, max = children.length; i < max; i++) {
        children[i].parentNode.removeChild(children[i]);
        treeMutation.removedNodes.push(children[i]);
      }
    }
    /**
     * Replaces body in an element.
     *
     * @param {Node} node Node to replace body in.
     */

  }, {
    key: "_replaceComponentBody",
    value: function _replaceComponentBody(node) {
      if (node.querySelector) {
        var body = node.querySelector('ikea-component-body[data-body-id="' + this.componentBody.id.toString() + '"]');

        if (body && body !== this.componentBody.element) {
          body.parentNode.insertBefore(this.componentBody.element, body);
          body.parentNode.removeChild(body);
        }
      }
    }
    /**
     * Updates components rendered inside another element on the page.
     */

  }, {
    key: "_updateRenderInsideComponent",
    value: function _updateRenderInsideComponent() {
      for (var _i2 = 0, _Array$from = Array.from(this.componentElement.querySelectorAll('ikea-component[data-render-inside]')); _i2 < _Array$from.length; _i2++) {
        var element = _Array$from[_i2];
        var id = this.componentId + '_' + element.getAttribute('name') + '_' + (element.getAttribute('id') || '0');

        var renderInElement = this._movedElements.get(id);

        element.setAttribute('id', id);

        if (renderInElement) {
          this._movedReferenceElements.set(id, renderInElement);

          this._updateNodeChanges([renderInElement], [element], 0);
        } else {
          var parentElement = document.querySelector(element.getAttribute('data-render-inside'));

          if (parentElement) {
            var clonedElement = element.cloneNode(true);

            this._movedElements.set(id, clonedElement);

            this._movedReferenceElements.set(id, clonedElement);

            parentElement.appendChild(clonedElement);
          }
        }

        element.parentNode.removeChild(element);
      }
    }
    /**
     * Handles removal of components rendered inside another element on the page.
     */

  }, {
    key: "updateRemovedRenderInsideComponent",
    value: function updateRemovedRenderInsideComponent() {
      var _iterator3 = _createForOfIteratorHelper(this._movedElements),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              id = _step3$value[0],
              element = _step3$value[1];

          var renderedElement = this._movedReferenceElements.get(id);

          if (!renderedElement && element.parentNode) {
            element.parentNode.removeChild(element);

            this._movedElements.delete(id);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    /**
     * Updates changed nodes with changed node type.
     *
     * @param {DomMutation} treeMutation Tree mutation.
     * @param {Node[]} children Children.
     * @param {Node[]} newChildren New Children.
     * @param {number} i Index.
     */

  }, {
    key: "_updateChangedNodeType",
    value: function _updateChangedNodeType(treeMutation, children, newChildren, i) {
      if (newChildren[i].querySelectorAll) {
        this.componentManager.filterElements = Array.from(newChildren[i].querySelectorAll('ikea-component')).concat(this.componentManager.filterElements);
      }

      children[i].parentNode.insertBefore(newChildren[i], children[i]);
      children[i].parentNode.removeChild(children[i]);

      this._replaceComponentBody(newChildren[i]);

      treeMutation.addedNodes.push(newChildren[i]);
      treeMutation.removedNodes.push(children[i]);
      children[i] = newChildren[i];
    }
    /**
     * Removes white space nodes from elements.
     *
     * @param {NodeList|Node[]} nodes Nodes to check.
     */

  }, {
    key: "_removeWhiteSpaceNodes",
    value: function _removeWhiteSpaceNodes(nodes) {
      nodes = Array.from(nodes);

      for (var i = 0, max = nodes.length; i < max; i++) {
        var isWhiteSpace = nodes[i].nodeType === Node.TEXT_NODE && nodes[i].nodeValue.replace(/\s+/gm, '') === '';

        if (!nodes[i].parentNode || isWhiteSpace) {
          if (nodes[i].parentNode && isWhiteSpace) {
            nodes[i].parentNode.removeChild(nodes[i]);
          }
        } else {
          this._removeWhiteSpaceNodes(Array.from(nodes[i].childNodes));
        }
      }
    }
  }]);

  return ComponentDom;
}();

exports.default = ComponentDom;